import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis, Cell} from "recharts";
import { LineChart, Line } from "recharts";
import { Skeleton, Fade, Grow, IconButton } from "@mui/material";
import { TrendingUp, ChevronRight, Route } from "lucide-react";

import {ChartTooltip} from "./chartTooltip";
import React from "react";
import {useTranslate, useGo} from "@refinedev/core";
import dayjs from "dayjs";
import axiosInstance from "../../api/axios-config";



export const CreatedTrajet: React.FC = () => {
   const t = useTranslate();
   const go = useGo();

    const [dailyCreatedTrajet, setDailyCreatedTrajet] = React.useState<any[]>([])
    const [isLoading, setIsLoading] = React.useState<boolean>(true);

    // Calculate total journeys
    const totalJourneys = React.useMemo(() => {
      return dailyCreatedTrajet.reduce((sum, item) => sum + (item.value || 0), 0);
    }, [dailyCreatedTrajet]);

    const getCreatedTrajet = async () => {
        setIsLoading(true);
        try {
            const start = dayjs().subtract(15, "days").startOf("day").format("YYYY-MM-DD")
            const {data: results} = await axiosInstance.get(`/notifications/stats/created-trajet?startDate=${start}`)

            const formattedData = Object.keys(results).map((key) => {
                return {
                    date: dayjs(key).format('DD/MM'),
                    fullDate: dayjs(key).format('DD/MM/YYYY'),
                    title: 'Trajet',
                    value: results[key] as number
                }
            })

            setDailyCreatedTrajet(formattedData)
        } catch (error) {
            setDailyCreatedTrajet([])
        } finally {
            setIsLoading(false);
        }
    }

    React.useEffect(() => {
        getCreatedTrajet()
    }, [])

    return (
      <Box
        sx={{
          height: "100%",
          background: "linear-gradient(135deg, #FF9800 0%, #F57C00 100%)",
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Navigation Button */}
        <IconButton
          onClick={() => go({ to: "/journeys" })}
          sx={{
            position: 'absolute',
            top: 16,
            right: 16,
            zIndex: 3,
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
            color: 'white',
            width: 36,
            height: 36,
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.25)',
            },
          }}
        >
          <ChevronRight size={18} />
        </IconButton>

        <Stack sx={{ position: 'relative', zIndex: 2, p: 3, flex: 1 }}>
          <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 1 }}>
            {/* Icon */}
            <Route size={40} color="rgba(255, 255, 255, 0.9)" />
            <Typography
            variant="h4"
            sx={{
              color: "#fff",
              fontWeight: 800,
              mb: 0.5,
              fontFamily: 'Inter, sans-serif',
              letterSpacing: '-0.02em',
              lineHeight: 1,
            }}
          >
              {isLoading ? '--' : totalJourneys}
            </Typography>
          </Stack>
          <Typography
            variant="h6"
            sx={{
              color: "rgba(255, 255, 255, 0.95)",
              fontWeight: 600,
              mb: 1,
              fontFamily: 'Inter, sans-serif',
              letterSpacing: '-0.01em',
            }}
          >
            {t("dashboard.createdTrajet")}
          </Typography>
          <Typography
            sx={{ color: "rgba(255, 255, 255, 0.8)", fontWeight: 500, fontFamily: 'Inter, sans-serif', fontSize: 14 }}
          >
            {t("dashboard.createdTrajetSubtitle")}
          </Typography>
        </Stack>
        <Box sx={{ flex: 1, mb: 2, px: 2, position: 'relative', zIndex: 2 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={dailyCreatedTrajet} margin={{ top: 10, right: 0, left: -20, bottom: 20 }}>
              <Line
                type="monotone"
                dataKey="value"
                stroke="#fff"
                strokeWidth={3}
                dot={{ r: 5, fill: '#fff', stroke: '#F57C00', strokeWidth: 2 }}
                activeDot={{ r: 7, fill: '#F57C00', stroke: '#fff', strokeWidth: 2 }}
                animationDuration={1500}
              />
              <Tooltip content={<ChartTooltip />} />
            </LineChart>
          </ResponsiveContainer>
        </Box>
      </Box>
    );
};
